<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_fiscal"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nº Fiscal</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="chave"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Chave</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Inicial"
              v-model="dt_inicio"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>

          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="hr_inicio"
                v-mask="'##:##'"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Hora Inicial</label
              >
            </div>
          </b-col> 

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data Final"
              v-model="dt_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="hr_fim"
                v-mask="'##:##'"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Hora Final</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="embarcacao_id"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Navio</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_viagem"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Viagem</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="des_nome"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Razão Social Destinatário</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="des_cnpj"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ Destinatário</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="tom_nome"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Razão Social Tomador</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="tom_cnpj"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ Tomador</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="rem_nome"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Razão Social Remetente</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="rem_cnpj"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ Remetente</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="rec_nome"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Razão Social Recebedor</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="rec_cnpj"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ Recebedor</label
              >
            </div>
          </b-col>

          <b-col sm="3" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="usuario_inc"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Email de Usuário Inclusão</label
              >
            </div>
          </b-col>

          <b-col sm="3" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_nf"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Num NF</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="status_sefaz"
              :options="optionsLivStatusSefaz"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status Sefaz"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="status_doc"
              :options="optionsLivStatusDoc"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status Documento"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="tp_operacao"
              :options="optionsLivTpOperacao"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Operação"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="tp_processo"
              :options="optionsLivTpProcesso"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Processo"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="municipio_inicio"
              :options="optionsMunicipio"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Município Início"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="municipio_fim"
              :options="optionsMunicipio"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Município Fim"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="modal"
              :options="optionsModal"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Modal"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <multiselect
              v-model="tp_doc"
              :options="this.$parent.optionsTpDoc"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Tipo de documento"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <!-- <b-col class="m-t-5px p-a-0">
            <multiselect
              v-model="recebedor"
              :options-limit="300"
              :limit="2"
              :limit-text="limitText"
              :options="optionsRecebedor"
              track-by="value"
              label="label"
              id="recebedor"
              :hide-selected="true"
              placeholder="Recebedor ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingRecebedor"
              @search-change="listaRecebedor"
            ></multiselect>
          </b-col> -->
          <b-col sm="6" md="4" class="p-0">
            <b-container>
              <b-col sm="6" md="6">
                <b-form-checkbox
                  v-model="averbado"
                  value="1"
                  unchecked-value="2"
                >
                  Averbados
                  <span
                    v-b-tooltip
                    title="Se marcado irá retornar documentos averbados na listagem"
                    placement="top"
                    >[?]</span
                  >
                </b-form-checkbox>
              </b-col>
              <b-col sm="6" md="6">
                <b-form-checkbox
                  v-model="consulta_completa"
                  value="1"
                  unchecked-value="2"
                >
                  Consulta Completa
                  <span
                    v-b-tooltip
                    title="Se marcado irá retornar consulta completa do documento"
                    placement="top"
                    >[?]</span
                  >
                </b-form-checkbox>
              </b-col>
            </b-container>
          </b-col>
          <div style="margin-left: auto">
            <b-col sm="6" md="2" class="m-t-5px">
              <div class="input-group-btn">
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn btn-secondary btn-outline"
                    @click="doFilter"
                    :disabled="vuetableFilterButton"
                  >
                    Filtrar
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary btn-outline"
                    @click="resetFilter"
                    :disabled="vuetableFilterButton"
                  >
                    Limpar
                  </button>
                </div>
              </div>
            </b-col>
          </div>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],

      num_fiscal: "",
      chave: "",
      dt_inicio: "",
      hr_inicio: "",
      dt_fim: "",
      hr_fim: "",
      embarcacao_id: "",
      num_viagem: "",
      des_nome: "",
      tom_nome: "",
      des_cnpj: "",
      tom_cnpj: "",
      rem_nome: "",
      rem_cnpj: "",
      rec_nome: "",
      rec_cnpj: "",
      tp_doc: "",
      averbado: "",
      recebedor: "",
      consulta_completa: "",
      usuario_inc: "",
      num_nf: "",
      optionsRecebedor: [],
      isLoadingRecebedor: false,
      optionsLivStatusSefaz: [],
      status_sefaz: [],
      optionsMunicipio: [],
      municipio_inicio: [],
      municipio_fim: [],
      optionsLivStatusDoc: [],
      optionsLivTpOperacao: [],
      optionsLivTpProcesso: [],
      status_doc: [],
      tp_operacao: [],
      tp_processo: [],
      optionsportoEmbarque: [],
      porto_embarque: [],
      optionsportoDestino: [],
      porto_destino: [],
      optionsModal: [],
      modal: [],
      data_filter: [],
      helpForm: new Form({ search: "", statusRecord: [], params: [] }),
    };
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.dt_inicio_label = this.dt_inicio;
      this.hr_inicio_label = this.hr_inicio;
      this.dt_fim_label = this.dt_fim;
      this.hr_fim_label = this.hr_fim;
      this.dt_inicio = this.formatDateSubmit(this.dt_inicio);
      this.dt_fim = this.formatDateSubmit(this.dt_fim);
      this.data_filter = {
        num_fiscal: this.num_fiscal,
        chave: this.chave,
        embarcacao_id: this.embarcacao_id,
        num_viagem: this.num_viagem,
        des_nome: this.des_nome,
        tom_nome: this.tom_nome,
        des_cnpj: this.des_cnpj,
        tom_cnpj: this.tom_cnpj,
        rem_nome: this.rem_nome,
        rem_cnpj: this.rem_cnpj,
        rec_nome: this.rec_nome,
        rec_cnpj: this.rec_cnpj,
        recebedor: this.recebedor,
        status_sefaz: this.status_sefaz,
        status_doc: this.status_doc,
        tp_operacao: this.tp_operacao,
        tp_processo: this.tp_processo,
        porto_embarque: this.porto_embarque,
        porto_destino: this.porto_destino,
        municipio_inicio: this.municipio_inicio,
        municipio_fim: this.municipio_fim,
        dt_inicio: this.dt_inicio,
        hr_inicio: this.hr_inicio,
        dt_fim: this.dt_fim,
        hr_fim: this.hr_fim,
        modal: this.modal,
        averbado: this.averbado,
        consulta_completa: this.consulta_completa,
        usuario_inc: this.usuario_inc,
        num_nf: this.num_nf,
        tp_doc: this.tp_doc,
      };
      this.$events.fire("filter-set", this.data_filter);
      this.dt_inicio = this.dt_inicio_label;
      this.hr_inicio = this.hr_inicio_label;
      this.dt_fim = this.dt_fim_label;
      this.hr_fim = this.hr_fim_label;
    },
    resetFilter() {
      this.num_fiscal = ""; // clear the text in text input
      this.chave = "";
      this.embarcacao_id = "";
      this.num_viagem = "";
      this.des_nome = "";
      this.tom_nome = "";
      this.des_cnpj = "";
      this.tom_cnpj = "";
      this.rem_nome = "";
      this.rem_cnpj = "";
      this.rec_nome = "";
      this.rec_cnpj = "";
      this.recebedor = "";
      this.status_sefaz = "";
      this.status_doc = "";
      this.tp_processo = "";
      this.tp_operacao = "";
      this.porto_embarque = "";
      this.porto_destino = "";
      this.municipio_inicio = "";
      this.municipio_fim = "";
      this.dt_inicio = "";
      this.hr_inicio = "";
      this.dt_fim = "";
      this.hr_fim = "";
      this.modal = "";
      this.tp_doc = "";
      this.averbado = "";
      this.consulta_completa = "";
      this.usuario_inc = "";
      this.num_nf = "";
      this.$events.fire("filter-reset");
    },
    getLivGeral() {
      this.helpForm
        .get("/api/cte/jsonlistfiltros")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status_sefaz.forEach((obj) => {
            this.optionsLivStatusSefaz.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.status_doc.forEach((obj) => {
            this.optionsLivStatusDoc.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_operacao.forEach((obj) => {
            this.optionsLivTpOperacao.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_processo.forEach((obj) => {
            this.optionsLivTpProcesso.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.portos.forEach((obj) => {
            this.optionsportoEmbarque.push({
              label: obj.cd,
              value: obj.porto_id,
            });
            this.optionsportoDestino.push({
              label: obj.cd,
              value: obj.porto_id,
            });
          });

          response.municipios.forEach((obj) => {
            this.optionsMunicipio.push({
              label: obj.nome,
              value: obj.municipio_id,
            });
          });

          response.modal.forEach((obj) => {
            this.optionsModal.push({ label: obj.descr, value: obj.bmodal_id });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    listaRecebedor(search) {
      if (search.length >= 3) {
        this.isLoadingRecebedor = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/")
          .then((response) => {
            this.optionsRecebedor = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsRecebedor.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    )+
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ),
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsRecebedor.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.cpf,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsRecebedor.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.cuit,
                });
              });
            }
            this.isLoadingRecebedor = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    formatTypedDate: function (dateString) {
      let result = dateString.split("/");
      return result[2] + "-" + result[1] + "-" + result[0] + "T00:00:00-03:00";
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
